module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/TF-6025d5fd3f1968cb10035db4f9d7baa9.png";